import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";

import { Icons } from "../../utils/icons";
import CloseButton from "./CloseButton";
import { InnerWrapper } from "./InnerWrapper";
import Text from "../shared/Text";
import Link from "../shared/Link";

interface Tab {
  name: string;
  icon: keyof Icons;
}

const AboutPanelContent: React.FC = () => {
  return (
    <Container>
      <PanelHeader>
        <InnerWrapper>
          <ResponsivePlayer>
            <ReactPlayer
              className="react-player"
              url={"https://www.youtube.com/watch?v=T0YDprUcURw"}
              width="100%"
              height="100%"
            />
          </ResponsivePlayer>
        </InnerWrapper>
      </PanelHeader>
      <InnerWrapper>
        <AboutPageContent>
          <Text as="h2">A Map of the Voices of England</Text>
          <Text as="p">
            This map was designed by letterpress artist and printmaker Alan Kitching with
            assistance from Joana Paranhos, in collaboration with English Heritage and
            Gravitywell. Watch the short film above to learn more about Alan’s work.
          </Text>
          <Text as="h3">English Heritage</Text>
          <Text as="p">
            English Heritage is a charity that cares for over 400 historic buildings,
            monuments and sites. Your support plays a vital role in keeping England’s
            history alive. Find out how you can support our work
            <Link to="https://www.english-heritage.org.uk/support-us">
              here
            </Link>.
        </Text>
          <SwagContainer>
            <DescriptionWrapper>
              <Text as="h3">
                Alan Kitching
              </Text>
              <Text as="p">
                Alan Kitching is one of the world’s foremost practitioners
                of letterpress typographic design and printmaking.
              </Text>
              <Text as="p">
                Visit our online shop for a range of collectables, gifts and
                accessories designed by Alan exclusively for English Heritage.
              </Text>
              <Text as="p">
                <Link to="https://www.english-heritageshop.org.uk/collections/england">
                  Visit the online shop
                </Link>
              </Text>
            </DescriptionWrapper>
            <ImageWrapper>
              <a target="_blank" rel="noopener noreferrer" href="https://www.english-heritageshop.org.uk/collections/england">
                <img src="slurp-mug.jpg" alt="Slurp Mug by Alan Kitching" />
              </a>
            </ImageWrapper>
          </SwagContainer>
        </AboutPageContent>

        <CloseButton marginTop={true} />
      </InnerWrapper>
    </Container>
  );
};

const AboutPageContent = styled.div`
  p {
    padding-bottom: 0.5rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
`;

const SwagContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const DescriptionWrapper = styled.div`
  width: 50%;
  @media (max-width: 960px) {
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  img {
    width: 300px;
  }
  @media (max-width: 960px) {
    width: 100%;
    padding: 1rem;
    img {
      max-width: 260px;
      width: 100%;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-bottom: 2.5rem;
  @media (max-width: 960px) {
    padding-bottom: 6rem;
  }

  

`;

const PanelHeader = styled.div`
  padding-bottom: 2rem;
`;

const ResponsivePlayer = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export default AboutPanelContent;
